import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-uppercase" }, "Notifications", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_mark_all_read_btn = _resolveComponent("mark-all-read-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_user_notification_item = _resolveComponent("user-notification-item")!
  const _component_view_all_notifications_btn = _resolveComponent("view-all-notifications-btn")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { "no-wrap": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, { overline: "" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              (_ctx.userNotifications.length)
                ? (_openBlock(), _createBlock(_component_mark_all_read_btn, {
                    key: 0,
                    class: "q-mx-xs",
                    "user-id": _ctx.userId,
                    onMarkedRead: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('marked-read')))
                  }, null, 8, ["user-id"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNotifications, (userNotification) => {
        return (_openBlock(), _createBlock(_component_user_notification_item, {
          key: userNotification.id,
          "user-notification": userNotification,
          onMarkedOneRead: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('marked-one-read', $event)))
        }, null, 8, ["user-notification"]))
      }), 128)),
      (!_ctx.userNotifications.length)
        ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, { caption: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("No unread notifications.")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_item, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_view_all_notifications_btn, {
                "user-id": _ctx.userId,
                flat: ""
              }, null, 8, ["user-id"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}